export default {
  picks: {
    imageImport: {
      dropzoneBody: "Importiere ein Foto und wir erfassen die Tipps für dich.",
      dropzoneCta: "Hier klicken oder per Drag-and-drop hochladen",
      preparingResults: "Ergebnisse werden vorbereitet",
      adding: "Wird hinzugefügt...",
      importedPicks: "Importierte Tipps",
    },
    actions: {
      findTrends: "Trends finden",
    },
    labels: {
      sgpPricingUnavailable: "SGP-Preis nicht verfügbar",
    },
    plusPromo: {
      description: "Erhalte Zugang zu erweiterten Plays und tieferen Einblicken",
    },
  },
};
